import React, { useState } from "react"
import { Button, Modal, ModalFooter, ModalHeader } from "reactstrap"

// A dialog whose draft is kept until the administrator discards it: closing it with unsaved changes asks first (CPanel lessons,
// 2026-09-21). `children` is the body; `actions` the footer's buttons after the close button (`closeLabel`); `hint` what they wait
// for, on the footer's left.
export default function DraftModal({ id, title, size, dirty, onClose, closeLabel = "Cancel", actions, hint, children }) {
  const [leaving, setLeaving] = useState(false)
  const close = () => (dirty ? setLeaving(true) : onClose())
  return <Modal isOpen centered size={size} toggle={close} labelledBy={id}>
    <ModalHeader id={id} toggle={close}>{title}</ModalHeader>
    {children}
    {leaving ? <ModalFooter className="justify-content-between">
      <span className="text-danger">You have unsaved changes.</span>
      <div><Button color="light" className="mr-2" onClick={() => setLeaving(false)}>Keep editing</Button><Button color="danger" onClick={onClose}>Discard changes</Button></div>
    </ModalFooter> : <ModalFooter>
      {hint && <span className="small text-muted mr-auto">{hint}</span>}
      <Button color="light" onClick={close}>{closeLabel}</Button>{actions}
    </ModalFooter>}
  </Modal>
}
